<app-loading-spinner *ngIf="appService.raIsLoading"></app-loading-spinner>

<div class="agreement-form-area body-data">
  <div class="agreement-area">
    <form class="form" [formGroup]="agreementForm">
      <table class="form-container" cellspacing="0">
        <tr>
          <div class="title">Rate Agreement</div>
        </tr>

        <tr class="accord-area">
          <div class="input-item" [ngClass]="this.operation === 'add'?'enable-field':'disable-field'">
            <label for='rateNumber' class='innerLabel required-icon' >Rate Agreement Number</label>
            <input type='text' name="rateNumber"  [tabindex]="this.operation === 'add' ? 1 : -1"  (keyup)="onRateNumber($event.target)" formControlName="rateNumber" size='50'
              placeholder="Enter Rate Agreement Number" tabindex="1" />
          </div>

          <div class="input-item" style="position: relative;">
            <label for='effectiveDate' class='required-icon innerLabel'>Effective Date</label>
              <!-- <input matInput  type="text" style="font-size: 16px;text-transform: uppercase; padding-left: 15px;padding-top:15px; cursor: pointer;"
                date-date-format="DD/MM/YYYY" class="form-field custom-date"
                bsDatepicker
                formControlName="effectiveDate" (keydown)="onKeyDown($event)"
                [bsConfig]="tableService.bsConfig" (bsValueChange)="onDaetChange($event,'effectiveDate')"
                placeholder="DD/MM/YYYY"
                name="effectiveDate"tabindex="1" />  -->
                
                <input type="text" matInput class="form-field dateFilter" placeholder="DD/MM/YYYY" style="font-size: 16px;text-transform: uppercase; padding-left: 15px;padding-top:15px; cursor: pointer;"  readonly  
                tabindex="1" formControlName="effectiveDate"  [matDatepicker]="effectivepicker"  (click)="tableService.matDatePicker(effectivepicker,'effectiveDate')" (dateChange)="onDateChange($event, 'effectiveDate')"/> 
                <mat-datepicker #effectivepicker></mat-datepicker>
          </div>
          <div class="input-item">
            <label for='expiryDate' class='required-icon innerLabel'>Expiry Date</label>
              <!-- <input matInput  type="text" style="font-size: 16px;text-transform: uppercase; padding-left: 15px;padding-top:15px; cursor: pointer;"
              date-date-format="DD/MM/YYYY" class="form-field custom-date"
              bsDatepicker
              formControlName="expiryDate" (keydown)="onKeyDown($event)" [minDate]="minDate"
              [bsConfig]="tableService.bsConfig" (bsValueChange)="onDaetChange($event,'expiryDate')"
              placeholder="DD/MM/YYYY"
              name="expiryDate"tabindex="1" /> -->
              <input type="text" matInput class="form-field dateFilter" placeholder="DD/MM/YYYY" style="font-size: 16px;text-transform: uppercase; padding-left: 15px;padding-top:15px; cursor: pointer;"  readonly  
                tabindex="1" [matDatepicker]="expirypicker" formControlName="expiryDate"  [min]="minDate"  (click)="tableService.matDatePicker(expirypicker,'expiryDate')" (dateChange)="onDateChange($event, 'expiryDate')"/> 
                <mat-datepicker #expirypicker></mat-datepicker>
          </div>

          <div class="input-item disable-field" (keydown)="onKeyDown($event)">
            <label for='supersedes' class='innerLabel'>Supersedes RA No</label>
            <input type='text' name="supersedes" formControlName="supersedes" size='50'
              placeholder="Enter Supersedes RA No" tabindex="-1"/>
          </div>

          <div class="input-item disable-field" (keydown)="onKeyDown($event)">
            <label for='revisionNum' class='required-icon innerLabel'>Revision Number</label>
            <input type='number' name="revisionNum" formControlName="revisionNum" size='50'
              placeholder="Enter Revision Number" tabindex="-1"/>
          </div>
          <div class="input-item">
            <label for='initalDate' class='required-icon innerLabel'>Initial Contract Effective Date</label>
              <!-- <input matInput  type="text" style="font-size: 16px;text-transform: uppercase; padding-left: 15px;padding-top:15px;cursor: pointer;"
                date-date-format="DD/MM/YYYY" class="form-field custom-date"
                bsDatepicker
                formControlName="initalDate" (keydown)="onKeyDown($event)" 
                [bsConfig]="tableService.bsConfig" (bsValueChange)="onDaetChange($event,'initalDate')"
                placeholder="DD/MM/YYYY"
                name="initalDate" tabindex="1"/> -->
                <input type="text" matInput class="form-field dateFilter" placeholder="DD/MM/YYYY" style="font-size: 16px;text-transform: uppercase; padding-left: 15px;padding-top:15px; cursor: pointer;"  readonly  
                tabindex="1" formControlName="initalDate"  [matDatepicker]="initiatepicker" (click)="tableService.matDatePicker(initiatepicker,'initalDate')" (dateChange)="onDateChange($event, 'initalDate')"/> 
                <mat-datepicker #initiatepicker></mat-datepicker>
          </div>
          <div class="input-item disable-field" (keydown)="onKeyDown($event)">
            <label for='oldExpiryDate' class='innerLabel'>Old Expiry Date</label>
            <input type="text" name="oldExpiryDate" formControlName="oldExpiryDate" size='50'
              placeholder="Enter Old Expiry Date" tabindex="-1"/>
          </div>
        </tr>
      </table>

      <table class="form-container" cellspacing="0">
        <tr>
          <div class="title">Details</div>
        </tr>
        <tr class="accord-area">
          <div class="input-item" [ngClass]="(+(this.agreementForm.get('revisionNum')?.value) !=1)?'disable-field':'enable-field'">
            <label for='gsdb' class='required-icon innerLabel'>GSDB</label>
            <select formControlName="gsdb" (click)="onSelectClick('gsdb')" [tabindex]="(operation !=='edit') ? 1 : -1" (change)="onOptionChange($event.target,'gsdb')">
              <option disabled value="">Select GSDB</option>
              <option *ngFor="let option of gsdbListArr" [value]="option.CarrierID">
                {{ option.ContractGSDB }}
              </option>
            </select>
          </div>

          <div class="input-item" [ngClass]="(selectedContact || (operation === 'edit' ))?'enable-field':'disable-field'"> <!--&& copyActivity-->
            <label for='contractName' class='required-icon innerLabel'>Contact Name</label>
            <select formControlName="contractName" (click)="onSelectClick('contactName')" (change)="onOptionChange($event.target,'contactName')"
            [tabindex]="selectedContact ? 1 : -1">
              <option disabled value="">Select Contact Name</option>
              <option *ngFor="let option of contactNAmeArr" [value]="option.ContactID">
                {{ (option.LastName?option.LastName:'')+" "+(option.FirstName? option.FirstName:'')}}
              </option>
            </select>
          </div>

          <div class="input-item">
            <label for='marketTest' class='innerLabel'>Market Test</label>
            <input type='text' name="marketTest" formControlName="marketTest" size='50'
              placeholder="Enter Market Test" tabindex="1"/>
          </div>

          <div class="input-item">
            <label for='buyermail' class='required-icon innerLabel'>Buyer Email</label>
              <select formControlName="buyermail" tabindex="1" (click)="onSelectClick('buyerEmail')" (change)="onOptionChange($event.target,'buyerEmail')">
                <option disabled value="">Select Buyer Email</option>
                <option *ngFor="let option of buyerMail" [value]="option.ContactID">
                  {{ option.Email }}
                </option>
              </select>
          </div>

          <div class="input-item disable-field" (keydown)="onKeyDown($event)">
            <label for='carrierName' class='required-icon innerLabel'>Name</label>
            <input type='text' name="carrierName" formControlName="carrierName" size='50'
              placeholder="Enter Carrier Name" tabindex="-1"/>
          </div>
          
          <div class="input-item disable-field" (keydown)="onKeyDown($event)">
            <label for='email' class='required-icon innerLabel'>Email</label>
            <input type='email' name="email" tabindex="-1" formControlName="email" size='50' placeholder="Enter email" />
          </div>

          <div class="input-item item-row-2">
            <label for='revision' class='innerLabel'>Reason for Revision</label>
            <textarea formControlName="revision" tabindex="1" size='500' placeholder="Reason for Revision" maxlength="250" (input)="updateRevisionRemainingChars($event)" (keydown)="handleTextareaKeydown($event)"></textarea>
            <small class="char-counter"  *ngIf="isActiveRevision"  style="display: block; text-align: right; margin-top: -35px;margin-right: 15px; color: #666;">
              {{revisionRemainingChars}} characters remaining
            </small>
          </div>

          <div class="input-item disable-field" (keydown)="onKeyDown($event)">
            <label for='buyerName' class='required-icon innerLabel'>Buyer Name</label>
            <input type='text' tabindex="-1" name="buyerName" formControlName="buyerName" size='50' placeholder="Enter Buyer Name" />
          </div>

          <div class="input-item disable-field" (keydown)="onKeyDown($event)">
            <label for='street' class='innerLabel'>Street</label>
            <input type='text' name="street" formControlName="street" size='50' placeholder="Enter Street" tabindex="-1"/>
          </div>

          <div class="input-item disable-field" (keydown)="onKeyDown($event)">
            <label for='phone' class='innerLabel'>Telephone</label>
            <input type='text' tabindex="-1" name="phone" formControlName="phone" size='50' placeholder="Enter Phone" />
          </div>

          <div class="input-item disable-field" (keydown)="onKeyDown($event)">
            <label for='buyerPhone' class='innerLabel'>Buyer Telephone</label>
            <input type='text' name="buyerPhone" tabindex="-1" formControlName="buyerPhone" size='50' placeholder="Enter Phone" />
          </div>

          <!-- <div class="input-item disable-field" (keydown)="onKeyDown($event)">
            <label for='buyerCode' class='required-icon innerLabel'>Buyer Code</label>
            <input type='text' name="buyerCode" formControlName="buyerCode" size='50'
              placeholder="Enter Buyer Code" tabindex="-1"/>
          </div> -->

          <!-- <div class="input-item">
            <label for='postcode' class='innerLabel'>Postcode</label>
            <input type='number' name="postcode" formControlName="postcode" size='50' placeholder="Enter Postcode" />
          </div> -->

          <div class="input-item disable-field" (keydown)="onKeyDown($event)">
            <label for='city' class='innerLabel'>City</label>
            <input type='text' name="city" formControlName="city" size='50' placeholder="Enter City" tabindex="-1"/>
          </div>

          <div class="input-item items-row-4">
            <label for='description' class='required-icon innerLabel'>Description of Service</label>
            <textarea type='text' name="description" formControlName="description" size='500' maxlength="1024"
              placeholder="Description of Service" tabindex="1"  (input)="updateDesRemainingChars($event)" (keydown)="handleTextareaKeydown($event)"
              ></textarea>
              <small class="char-counter" *ngIf="isActiveDescription" style="display: block; text-align: right; margin-top: -35px;margin-right: 15px; color: #666;">
                {{desRemainingChars}} characters remaining
              </small>
          </div>

          <div class="input-item item-row-2">
            <label for='specification' class='innerLabel'>Specifications</label>
            <textarea type='text' name="specification" formControlName="specification" size='500' maxlength="350"
              placeholder="Specifications" tabindex="1" (input)="updateSpecRemainingChars($event)" (keydown)="handleTextareaKeydown($event)"></textarea>
              <small class="char-counter" *ngIf="isActiveSpec" style="display: block; text-align: right; margin-top: -35px;margin-right: 15px; color: #666;">
                {{specRemainingChars}} characters remaining 
              </small>
          </div>

          <div class="input-item disable-field" (keydown)="onKeyDown($event)">
            <label for='buyerLocation' class='innerLabel'>Buyer Location</label>
            <input type='text' name="buyerLocation" formControlName="buyerLocation" size='50'
              placeholder="Enter Buyer Location" tabindex="-1"/>
          </div>

          <div class="input-item disable-field" (keydown)="onKeyDown($event)">
            <label for='country' class='required-icon innerLabel'>Country</label>
            <input type='text' name="country" tabindex="-1" formControlName="country" size='50' placeholder="Enter Country" />
          </div>

          <div class="input-item"></div>


          <!-- <div class="input-item"></div> -->
          <div class="input-item disable-field" (keydown)="onKeyDown($event)">
            <label for='taxCode' class='innerLabel'>VAT Code</label>
            <input type='text' name="taxCode" tabindex="-1" formControlName="taxCode" size='50' placeholder="Enter VAT Tax Code" />
          </div>

          <div class="input-item item-row-2">
            <label for='country' class='innerLabel'>Volume Guarantees</label>
            <textarea formControlName="guarantees" tabindex="1" size='500' placeholder="Volume Guarantees"></textarea>
          </div>

          <div class="input-item"></div>

          <div class="input-item  disable-field" (keydown)="onKeyDown($event)">
            <label for='zipCode' class='innerLabel'>Zip Code</label>
            <input type='text' name="zipCode" tabindex="-1" formControlName="zipCode" size='50' placeholder="Enter Zip Code" />
          </div>

          
        </tr>
      </table>

      <table class="form-container" cellspacing="0">
        <tr>
          <div class="title">Terms</div>
        </tr>
        <tr class="accord-area">
          <div class="input-item">
            <label for='autoExtent' class='required-icon innerLabel'>Auto Extension Flag</label>
            <select formControlName="autoExtent" (change)="onOptionChange($event.target,'autoExtent')" tabindex="1">
              <option disabled value="">Select Flag</option>
              <option *ngFor='let option of ["Yes","No"]' [value]="option">
                {{ option }}
              </option>
            </select>
          </div>

          <div class="input-item">
            <label for='autoComment' class='innerLabel'>Auto Extension Comment</label>
            <input type='text' name="autoComment" formControlName="autoComment" size='50'
              placeholder="Enter Auto Extension Comment" tabindex="1"/>
          </div>

          <div class="input-item" [ngClass]="autoFlag?'enable-field':'disable-field'" (keydown)="onKeyDown($event, autoFlag)">
            <label for='noticePeriod' [ngClass]="autoFlag?'required-icon':'remove-req-icon'" class='innerLabel' >Notice Period (Months)</label>
            
            <!-- <select formControlName="noticePeriod" (change)="onOptionChange($event.target,'np')">
              <option disabled value="">Select</option>
              <option *ngFor="let option of noticePeriodList" [value]="option.value">
                {{ option.label }}
              </option>
            </select> -->
            <input type='number' name="noticePeriod" formControlName="noticePeriod" size='50'
            placeholder="Enter Notice Period " [tabindex]="autoFlag ? 1 : -1"/>
          </div>

          <div class="input-item" [ngClass]="autoFlag?'enable-field':'disable-field'" (keydown)="onKeyDown($event, autoFlag)">
            <label for='renewal' [ngClass]="autoFlag?'required-icon':'remove-req-icon'" class='innerLabel'>Renewal Term (Months)</label>
            <input type='number' name="renewal" formControlName="renewal" size='50'
            placeholder="Enter Renewal " [tabindex]="autoFlag? 1 : -1"/>
            <!-- <select formControlName="renewal" (change)="onOptionChange($event.target,'renewal')">
              <option disabled value="">Select Renewal</option>
              <option *ngFor="let option of renewalList" [value]="option.value">
                {{ option.label }}
              </option>
            </select> -->
          </div>

          <div class="input-item">
            <label for='duration' class='required-icon innerLabel'>Contract Duration (Years)</label>
            <!-- <select formControlName="duration" (change)="onOptionChange($event.target,'duration')">
              <option disabled value="">Select Duration</option>
              <option *ngFor="let option of noticePeriodList" [value]="option.value">
                {{ option.label }}
              </option>
            </select> -->
            <input type='number' name="duration" formControlName="duration" size='50'
            placeholder="Enter Duration " tabindex="1"/>
          </div>

          <div class="input-item">
            <label for='payment' class='required-icon innerLabel'>Payment Term (Days)</label>
            <input type='number' name="payment" formControlName="payment" size='50'
            placeholder="Enter payment " tabindex="1"/>
            <!-- <select formControlName="payment" (change)="onOptionChange($event.target,'payment')">
              <option *ngFor="let option of paymentList" [value]="option.value">
                {{ option.label }}
              </option>
            </select> -->
          </div>

          <div class="input-item">
            <label for='commodity' class='required-icon innerLabel'>Commodity </label>
            <select formControlName="commodity" (change)="onOptionChange($event.target,'commodity')" tabindex="1">
              <option disabled value=''>Select Commodity</option>
              <option *ngFor="let option of commodityList" [value]="option.LookUpID">
                {{ option.LookUpName }}
              </option>
            </select>
          </div>

          <div class="input-item">
            <label for='currency' class='required-icon innerLabel'>Currency</label>
            <select formControlName="currency" (change)="onOptionChange($event.target,'currency')" tabindex="1">
              <option disabled value="">Select Currency</option>
              <option *ngFor="let option of currencyList" [value]="option.LookUpID">
                {{ option.LookUpName }}
              </option>
            </select>
          </div>

          <div class="input-item">
            <label for='retentionPeriod' class='required-icon innerLabel'>Record Retention Period (Years)</label>
            <input type='number' name="retentionPeriod" formControlName="retentionPeriod" size='50' (change)="onOptionChange($event.target,'retentionPeriod')"
              placeholder="Enter Record Retention Period" tabindex="1"/>
          </div>

          <div class="input-item disable-field" (keydown)="onKeyDown($event)">
            <label for='retentionDays' class='innerLabel'>Record Retention Date</label>
            <input type="text" name="retentionDays" formControlName="retentionDays" size='50'
              placeholder="Enter Record Retention Date" tabindex="-1" />
          </div>

          <div class="input-item disable-field" (keydown)="onKeyDown($event)">
            <label for='gisclassfication' class='required-icon innerLabel'>GIS2 Classification</label>
            <input type='text' name="gisclassfication" formControlName="gisclassfication" size='50'
              placeholder="Enter GIS2 Classification" tabindex="-1"/>
          </div>

          <div class="input-item disable-field" (keydown)="onKeyDown($event)">
            <label for='gisNumber' class='required-icon innerLabel'>GIS1 Item Number</label>
            <input type='number' name="gisNumber" formControlName="gisNumber" size='50'
              placeholder="Enter GIS1 Item Number" tabindex="-1"/>
          </div>

          <div class="input-item disable-field" (keydown)="onKeyDown($event)">
            <label for='createdDate' class='required-icon innerLabel'>Created (Date/Time)</label>
            <input type="text" name="createdDate" formControlName="createdDate" size='50'
              placeholder="Enter Created (Date/Time)" tabindex="-1"/>
          </div>

          <div class="input-item disable-field" (keydown)="onKeyDown($event)">
            <label for='createdBy' class='required-icon innerLabel'>Created by</label>
            <input type='text' name="createdBy" tabindex="-1" formControlName="createdBy" size='50' placeholder="Enter Created by" />
          </div>

          <div class="input-item disable-field" (keydown)="onKeyDown($event)">
            <label for='modifiedDate' class='required-icon innerLabel'>Modified (Date/Time)</label>
            <input type="text" name="modifiedDate" formControlName="modifiedDate" size='50'
              placeholder="Enter Modified (Date/Time)" tabindex="-1"/>
          </div>

          <div class="input-item disable-field" (keydown)="onKeyDown($event)">
            <label for='modifiedBy' class='required-icon innerLabel'>Last Modified Name</label>
            <input type='text' name="modifiedBy" formControlName="modifiedBy" size='50'
              placeholder="Enter Modified By" tabindex="-1"/>
          </div>
        </tr>
      </table>

      <table class="form-container" cellspacing="0">
        <tr>
          <div class="title">Attachment</div>
          <div class="file-load-area">
             <img style="width: 25px;margin-bottom: 10px;" src="../../../../assets/images/upload-file-icon.png">
            <!-- <div class="drop-zone" style="margin-bottom: 5px;" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
                Drop here to upload or
            </div> -->
            <input type="file" [multiple]="true"  (change)="onFileSelected($event)"  style="display: none;"  #fileInput accept=".pdf,.docx,.doc,.xlsx,.xls,.ppt,.pptx,.csv,.txt,.png,.jpeg,.jpg"/>
            <div class="browse-txt" *ngIf="operation!=='view'" (click)="fileInput.click()">Browse Files</div>
            <span style="color: #666666; font-size: 12px;">*.pdf, *.docx, *.doc, *.xlsx, *.xls, *.ppt, *.pptx, *.csv, *.txt, *.png, *.jpeg, *.jpg </span>
             <span style="color: #666666; font-size: 12px;"> up to 500 KB/file and maximum 10 files</span>
              <div *ngIf="files?.length > 0" class="file-list">
                <div *ngFor="let file of files; let i = index" class="file-item">
                  <div class="file-area">
                    
                    <div style="display: flex;">
                      <mat-icon>description</mat-icon>
                      <span style="font-size: 12px;">{{ file.name }}</span>
                     
                    </div>
                    <span style="font-size: 10px;">{{file.size | filesize}}</span>
                  </div>
                  
                  <div class="icon-area">
                     <img *ngIf="operation!=='view'" src="../../../../assets/images/delete.png" style="cursor: pointer;"(click)="removeFile(i)" > 
                     <img src="../../../../assets/images/import-icon.png" style="cursor: pointer;"(click)="downloadFile(file)" > 
                  </div>
                </div>
              </div>
        </div>
        </tr>
      </table>
    </form>

  </div>
</div>
